import React from 'react';
import './NotFound.css';
import Navbar from './Navbar';
import Bottombar from './Bottombar';
import Hero from './Hero';
import heroImage from '../Website/5101597.jpg';
import { Home } from 'lucide-react';

const NotFound = () => (
  <div className="notfound-page">
    <Navbar />
    <Hero image={heroImage} eyebrow="Page Not Found" title="404" />
    <div className="notfound-content">
      <p className="notfound-text">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a href="/" className="notfound-btn notfound-btn-primary">
        <Home size={18} />
        Back to Home
      </a>
    </div>
    <Bottombar />
  </div>
);

export default NotFound;
